/**
 * Keep all static queries in this file.
 * Add new queries as necessary.
 * You add aliases if you need to access the same node more than once.
 * The `placeholderImage` is an example of an alias on the `file` node.
 *
 * Example of how to use this hook:
 * import { useGraphQL } from './src/hooks';
 *
 * const { site } = useGraphQL();
 *
 * return <h1>{site.siteMetadata.title}</h1>;
 */

import { graphql, useStaticQuery } from 'gatsby';

function useGraphQL() {
  const data = useStaticQuery(
    graphql`
      {
        site {
          siteMetadata {
            title
            description
            address {
              line1
              line2
              googleMaps
            }
            phone
            email
            hours {
              day
              time
            }
            siteUrl
            social {
              facebook
              instagram
            }
          }
        }
        placeholderImage: file(relativePath: { eq: "placeholder.jpg" }) {
          publicURL
        }
        ogImage: file(relativePath: { eq: "og-image.jpg" }) {
          publicURL
        }
      }
    `
  );

  return data;
}

export { useGraphQL };
